<template>
  <div class="step-final-container">
    <div class="step-header">
      <h2 class="step-title">{{ isUpdate ? 'Cronograma atualizado!' : 'Cronograma criado!' }}</h2>
    </div>

    <img
        src="https://jaleko-files.s3-sa-east-1.amazonaws.com/topicos-imagem/626815269fe52_character_created_schedule.svg"
        alt="Estudante monta sua agenda" class="mt-2 mt-lg-7">

    <div class="step-buttons mt-10">
      <v-btn rounded block width="246px" class="btn next-step-button primary-button mb-4" large color="#F47D3A"
             @click="goToHome">
        Ver Agenda
      </v-btn>

      <v-btn rounded outlined block width="246px" class="btn previous-step-button dark-button" large @click="reset">
        Criar novo cronograma
      </v-btn>
    </div>
  </div>
</template>
<script>

import './style.scss'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'FinalStep',

  computed: {
    ...mapGetters(['isUpdate'])
  },

  methods: {
    ...mapActions(['setCreationStep', 'setIsUpdate']),

    reset() {
      this.setCreationStep(1)
      this.setIsUpdate(false)
    },

    goToHome() {
      this.reset()
      this.$router.push({name: 'home'})
    }
  }
}
</script>
